import { useState } from "react"
import { useProfile } from "src/shared/hooks/useProfile"
import { useOnLogout } from "src/shared/components/navigation/header/Header.helpers"
import { Logo } from "src/shared/components/navigation/header/Header.sections"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import Icon from "src/shared/icons"
import "src/shared/components/navigation/header/Header.css"

function CalculadoraHeader(): JSX.Element {
    const { myProfile } = useProfile()
    const { onLogout } = useOnLogout()
    const [open, setOpen] = useState(false)

    return (
        <header className="header">
            <Logo />
            <div className="header__options" onClick={() => setOpen(!open)}>
                <Icon name="menu" className="header__options__icon" color="var(--white)" />
            </div>
            <Drawer
                className="header-sidebar"
                bgClassName="header-sidebar__bg"
                placement="right"
                bar={false}
                visible={open}
                onClose={() => setOpen(false)}
            >
                <div className="header-sidebar__head">
                    <div className="header-sidebar__head__info">
                        <p className="header-sidebar__head__label">
                            <strong className="header-sidebar__head__label__text">
                                {myProfile?.nombre} {myProfile?.apellido_paterno ?? ""}
                            </strong>
                            <span className="header-sidebar__head__label__text">{myProfile?.correo}</span>
                        </p>
                    </div>
                </div>
                <div className="header-sidebar__main">
                    <div />
                    <div className="header-sidebar__block">
                        <div className="header-sidebar__item" onClick={onLogout}>
                            <Icon name="logout" />
                            <span>Cerrar sesión</span>
                        </div>
                    </div>
                </div>
                <div className="header-sidebar__footer">
                    <img src={require("src/assets/png/logo_opacity.png")} height={26} alt="logo" />
                </div>
            </Drawer>
        </header>
    )
}

export default CalculadoraHeader
